import gql from 'graphql-tag';

export const START_PAGE_MUTATION = gql`
  mutation trackPage($contentPageId: Int!, $userFlowStepTrackId: Int!) {
    userFlowStepTrack {
      startContentPageCompletion(pageId: $contentPageId, trackingId: $userFlowStepTrackId) {
        id
      }
    }
  }
`;
